import React, { useContext } from 'react';
import { Formik, Form } from 'formik';
import FormikText from './formik/FormikText';
import FormikTextArea from './formik/FormikTextArea';
import EmailInput from './formik/EmailInput';
// import AttachmentsInputs from './formik/AttachmentsInputs'
import * as Yup from 'yup';
import axios from 'axios';
import useDates from '../../hooks/useDates';
import { QuoteContext } from '../QuoteManager';

const initialValues = {
  subject: 'Your eQuote from Athens Hair Transplants',
  client_email: '',
  // athens_email: 'info@athenshair.com',
  cc: '',
  message: '',
  // attachments: []
};

const validationSchema = Yup.object().shape({
  subject: Yup.string().required('Required'),
  client_email: Yup.string().email('Invalid email').required('Required'),
  // athens_email: Yup.string().email('Invalid email').required('Required'),
  cc: Yup.string().email('Invalid email'),
  message: Yup.string(),
  // attachments: Yup.array()
});

// const attachments = ['Pre Post Care', 'Brochure', 'Infographic', 'Refer a Friend', 'PCOS Brochure']

function SendEquote({ options, setDisplayContent }) {
  const dates = useDates();
  const { active } = useContext(QuoteContext);

  const onSubmit = (formValues, props) => {
    // axios.post(`http://localhost:5001/send_email`, {
    axios
      .post(`${process.env.REACT_APP_ATHENS_HEROKU_PATH}/send_email`, {
        recipient_email: formValues.client_email.trim(),
        cc: formValues.cc.trim(),
        subject: formValues.subject,
        message: formValues.message,
        // lender: active.lender.name !== LENDERS[0].name ? active.lender.name : undefined,
        lender: undefined,
        options: options,
        // attachments: formValues.attachments,
        dates: {
          issued: dates.today,
          expires: dates.expires,
        },
        tax: active.state.tax,
      })
      .then((res) => {
        console.log(res);
        props.setStatus('Success');
        setTimeout(() => {
          props.resetForm();
        }, 20000);
      })
      .catch((err) => {
        props.setStatus('Failed');
        setTimeout(() => {
          props.resetForm();
        }, 20000);
        console.log(err);
      })
      .finally(props.setSubmitting(false));
  };

  const handleCancel = (formik) => {
    formik.resetForm();
    setDisplayContent(null);
  };
  return (
    <div className='row justify-content-center py-5 athens-bg-dark-grey'>
      <div className='col-12'>
        <h3 className='text-center mb-4'>Email Quote</h3>
      </div>

      <div className='col-lg-11 col-xl-10 col-xxl-9'>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(formValues, props) => onSubmit(formValues, props)}
          validateOnChange={false}
        >
          {(formik) => {
            return (
              <Form id='send-equote' className='w-100 pb-4'>
                {formik.isSubmitting ? (
                  <span>Submitting...</span>
                ) : formik.status === 'Success' ? (
                  <div className='text-center'>
                    <p className='athens-text-primary display-6'>SUCCESS!</p>
                    <p className='athens-text-primary'>eQuote has been sent</p>
                    <button
                      type='button'
                      className='athens-btn athens-green-btn'
                      onClick={formik.resetForm}
                    >
                      Done
                    </button>
                  </div>
                ) : formik.status === 'Failed' ? (
                  <div>
                    <p className='text-danger fs-4'>Failed to send eQuote</p>
                    <button
                      type='button'
                      className='athens-btn athens-green-btn'
                      onClick={formik.resetForm}
                    >
                      Try Again
                    </button>
                  </div>
                ) : (
                  <>
                    <div className='row form-inputs-wrapper'>
                      <div className='col-md-5'>
                        <EmailInput
                          name='client_email'
                          label='Client Email'
                          placeholder='clientemail@mailbox.com'
                        />
                        {/* <FormikText name="subject" label="Subject" placeholder="Your eQuote from Athens Hair Transplants" type="text" /> */}
                        {/* <EmailInput name="athens_email" label="Athens Email" disabled /> */}
                        <EmailInput
                          name='cc'
                          label='CC'
                          optional
                          placeholder='janes@athenshair.com'
                        />
                      </div>
                      <div className='col-md-7'>
                        <FormikText
                          name='subject'
                          label='Subject'
                          placeholder='Your eQuote from Athens Hair Transplants'
                          type='text'
                        />
                        <FormikTextArea
                          name='message'
                          label='Message'
                          optional
                          placeholder='Hello...'
                          rows='1'
                        />
                        {/* <AttachmentsInputs attachments={attachments} name="attachments" formik={formik} /> */}
                      </div>
                    </div>
                    <div className='row flex-sm-row-reverse gy-3 justify-content-center mt-1 mt-lg-3'>
                      <div className='col-12 col-sm-auto text-center'>
                        <button
                          type='submit'
                          className='athens-btn athens-primary-btn'
                          style={{ width: '330px' }}
                          disabled={!formik.isValid}
                        >
                          Send Email
                        </button>
                      </div>

                      <div className='col-12 col-sm-auto text-center'>
                        <button
                          className='athens-btn athens-navy-btn'
                          style={{ width: '330px' }}
                          type='button'
                          onClick={() => handleCancel(formik)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

export default SendEquote;
